<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <BulkLinkedin :profileData="profileData" />
  </div>
</template>

<script>
// @ is an alias to /src
import BulkLinkedin from '@/components/BulkLinkedin.vue'
import { bulkParser } from '../domParser/parser'
import {
  setCookie,
  readCookie,
  postDomChangeAlert,
} from '../assets/util/commonUtil'
import { LI_PARSER_ERROR } from '../assets/util/constants/constants'

export default {
  name: 'home',
  components: {
    BulkLinkedin,
  },
  data: function () {
    return {
      profileData: null,
    }
  },
  methods: {
    addListenerForMsgFromPlugin() {
      const that = this
      window.addEventListener(
        'message',
        function (ev) {
          if (ev && ev.data && ev.data.type == 'li-bulk-mode') {
            if (ev.data.data) {
              const data = ev.data.data
              if (
                data.isServerParserEnabled !== undefined &&
                data.isServerParserEnabled === true
              ) {
                const config = {}
                config.htmlText = data.profileHTML ? data.profileHTML : ''
                config.currentUrl = data.currentUrl ? data.currentUrl : ''
                config.isProspectorParser = true
                bulkParser(config).then(function (parsedData) {
                  if (
                    parsedData &&
                    parsedData.domReadError !== undefined &&
                    parsedData.domReadError
                  ) {
                    if (readCookie(LI_PARSER_ERROR.BULK) == null) {
                      setCookie(LI_PARSER_ERROR.BULK)
                      const reportConfig = {
                        html: config.htmlText,
                        version: 'bulk',
                      }
                      setCookie(LI_PARSER_ERROR.SINGLE, 'true', 0, 1)
                      postDomChangeAlert(reportConfig)
                    }
                  }
                  that.profileData = {
                    profiles: parsedData,
                    isSalesNavigator: that.isSalesNavigator(
                      data.currentUrl,
                      parsedData
                    ),
                  }
                })
              } else {
                that.profileData = {
                  profiles: ev.data.data,
                  isSalesNavigator: that.isSalesNavigator(
                    data.currentUrl,
                    ev.data.data
                  ),
                }
              }
            }
          } else if (
            ev &&
            ev.data &&
            ev.data.data &&
            ev.data.type == 'li-user-data'
          ) {
            that.$store.state.liData = ev.data.data
          }
        },
        true
      )
    },
    isSalesNavigator(urlStr, data) {
      return urlStr
        ? urlStr.indexOf('/sales/') != -1
        : Array.isArray(data) && data.length
        ? data[0].isSalesNavigator
        : false
    },
  },
  beforeMount: function () {
    this.addListenerForMsgFromPlugin()
  },
}
</script>
